import Vue from 'vue';
import ElementUI from 'element-ui';
import VueCookie from 'vue-cookie';
import * as sentryPlugin from '@x-tech/fe-puma-lib-sentry-config/dist/vuePlugin';
import { traceInitVue } from '@x-tech/fe-trace-sdk-web';
import * as packagejson from '../package.json';

import store from './store/store';
import App from './App.vue';
import router from './router/router';

import 'reset-css';
import '@x-tech/fe-puma-element-theme/lib/index.css';
import './css/main.scss';
import { $_initWs } from '@/ws';

Vue.config.productionTip = false;
Vue.use(ElementUI, {
    size: 'mini',
});
Vue.prototype.$cookie = VueCookie;
Vue.use(sentryPlugin);

// 初始化 websocket 对象,  直接绑定在 Vue.prototype.$ws 上面了, 应该在登录时初始化，此处是为了避免因刷新页面导致的链接断开，所以需要从新初始化
$_initWs();

// 避免因为 $log 报错而崩溃
Vue.prototype.$log = function () {
    try {
        Vue.prototype.$_log.apply(null, arguments);
    } catch (e) {
        console.log(e);
    }
};

new Vue({
    render: h => h(App),
    router,
    store,
}).$mount('#app');

traceInitVue(
    'app',
    {
        productCode: 'PORTAL',
        productVersion: packagejson.version,
        env: window.XCConfig.VUE_APP_ENV,
    });
